//10.5.1.30 - Test
//10.5.1.30 - Preprod

import getOS from 'src/hooks/getOS';

export const COD_PARTICIPANTE = '1600';

export const getCanal = () => {
  if (typeof window === 'undefined') return 'web';
  if (!window.ReactNativeWebView) return 'web';
  return getOS() === 'Android' ? 'android' : 'ios';
};

const URL_TEST = false; //false para desarrollo, true para produccion
const KEYS = false; //false para desarrollo, true para produccion
const LOCAL_VPN = false; //false para desarrollo, true para produccion
const ENDPOINT_VPN_DIMOSERVICES = LOCAL_VPN ? 'http://10.5.1.30:8081/' : 'https://dimotest.cabal.coop.py/';
const ENDPOINT_VPN_BACKEND_DIMO = LOCAL_VPN ? 'http://10.5.1.30:8081/' : 'https://dimotest.cabal.coop.py/';
const ENDPOINT_VPN_WS_TARJETAHABIENTE = LOCAL_VPN ? 'http://10.5.1.30:8081/' : 'https://dimotest.cabal.coop.py/';

export const dimo_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_DIMOSERVICES}api-gateway-backend/dimoservices/rest` : '/api-gateway-backend/dimoservices/rest';

export const account_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}ws-dimo/dimo/catastro` : '/ws-dimo/dimo/catastro';

export const operations_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}ws-operaciones/dimo/operacion` : '/ws-operaciones/dimo/operacion';

export const auth_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}ws-user/user/login` : '/ws-user/user/login';

export const creditcard_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_WS_TARJETAHABIENTE}api-gateway-backend/ws-tarjetahabiente/tarjetaCredito` : '/api-gateway-backend//ws-tarjetahabiente/tarjetaCredito';

export const prepaidcard_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_WS_TARJETAHABIENTE}api-gateway-backend/ws-tarjetahabiente/tarjetaPrepaga` : '/api-gateway-backend/ws-tarjetahabiente/tarjetaPrepaga';

export const extract_creditcard_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_WS_TARJETAHABIENTE}api-gateway-backend/ws-tarjetahabiente/tarjetaCredito` : '/api-gateway-backend/ws-tarjetahabiente/tarjetaCredito';

export const extract_descargar_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_DIMOSERVICES}api-gateway-backend/facturacionelectronica/rest` : '/api-gateway-backend/facturacionelectronica/rest';

export const ceibo_prm_sp_services_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_WS_TARJETAHABIENTE}api-gateway-backend/ws-tarjetahabiente/prmservices/v2/sprunner` : '/api-gateway-backend/ws-tarjetahabiente/prmservices/v2/sprunner';

export const participants_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}ws-ceibo/dimo/ceibo` : '/ws-ceibo/dimo/ceibo';

export const transaction_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}ws-operaciones/dimo/operacion` : '/ws-operaciones/dimo/operacion';

export const payment_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_DIMOSERVICES}api-gateway-backend/PaymentGateway/rest` : '/api-gateway-backend/ws-payment-engine/PaymentGateway/rest';

export const coop_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}ws-cooperativa/coop/cooperativa` : '/ws-cooperativa/coop/cooperativa';

export const bank_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}api-gateway-backend/switchbancario/rest` : '/api-gateway-backend/switchbancario/rest';

export const kyc_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_DIMOSERVICES}kyc` : '/ws-user-kyc';

export const operaciones_dimo_service_api_url = process.env.REACT_APP_ENVIRONMENT === 'development' ? `${ENDPOINT_VPN_BACKEND_DIMO}api-gateway-backend/operacionesdimo/rest` : '/api-gateway-backend/operacionesdimo/rest';

// Se agrego validacion para url de afinidades, si es false es preprod, si es true es produccion
export const url_tp_dimo = true ? 'https://estatico.cabal.coop.py/public/dimo/afinidades' : 'https://estaticopre.cabal.coop.py/public/dimo/afinidades';


//se agrego para validar el periodo de facturacion, de acuerdo a la fecha, si es true es preprod, si es false es produccion
export const periodoFacturacionKude = false ? '202206' : '202306';
